import { h } from "preact";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { Tag } from "src/models/interfaces";
import { FunctionalComponent } from "preact";
import styles from "./portalTagStyles.css";
import { useEffect, useState } from "preact/hooks";
import {
  setShowAllKapps,
  setShowAllTags,
} from "../../../../../redux/slices/appearanceSlice";
interface IProps {
  selectAllTopics: () => void;
  isAllTopics: () => boolean;
  filtersToggleKappSelection: (kapp: any) => void;
  filterTagsForUI: (tag: Tag) => boolean;
  tagClicked: (tag: Tag) => void;
  removeTag: (tag: any) => void;
}
const PortalTags: FunctionalComponent<IProps> = ({
  filterTagsForUI,
  tagClicked,
  removeTag,
  selectAllTopics,
  isAllTopics,
  filtersToggleKappSelection,
}) => {
  const search = useAppSelector((state) => state.search);
  const appearance = useAppSelector((state) => state.appearance);
  const [openFolder, setOpenFolder] = useState(true);
  const [openTage, setOpenTage] = useState(true);
  const [updatedKapps, setUpdatedKapps] = useState(search.kapps);
  const [updatedTags, setUpdatedTags] = useState(search.tags);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (search.kapps?.length > 0) {
      setUpdatedKapps(search.kapps);
    }
    if (search.tags?.length > 0) {
      setUpdatedTags(search.tags);
    }
  }, [search.kapps, search.tags]);
  const handleTagsSearch = (e: any) => {
    const tempArray = search.tags.filter((tag: any) =>
      tag.value?.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setUpdatedTags(tempArray);
  };
  const handleKappSearch = (e: any) => {
    const tempArray = search.kapps.filter((kapp: any) =>
      kapp.name?.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setUpdatedKapps(tempArray);
  };
  return (
    <div>
      {search.kapps.length > 0 ? (
        <div className={styles.container}>
          <div className={styles.upperflexBox}>
            <div className={styles.flexBox}>
              <svg
                fill="#000000"
                height="12px"
                width="12px"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 330 330"
                xmlSpace="preserve"
                onClick={() => setOpenFolder(!openFolder)}
                style={{
                  transform: openFolder ? "rotate(90deg)" : "",
                  cursor: "pointer",
                }}
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    id="XMLID_222_"
                    d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001 c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213 C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606 C255,161.018,253.42,157.202,250.606,154.389z"
                  ></path>{" "}
                </g>
              </svg>
              <p className={styles.subTitle}>Folders:</p>
            </div>
            <input placeholder="Search folder" onChange={handleKappSearch} />
          </div>
          {openFolder && (
            <div style={{ marginTop: "0px", marginBottom: "10px" }}>
              <div
                onClick={selectAllTopics}
                className={
                  isAllTopics() ? styles.filterSelectedItem : styles.filtersItem
                }
              >
                <div></div>
                All
              </div>
              {(appearance.showAllKapps
                ? updatedKapps
                : updatedKapps.slice(0, 20)
              ).map((kapp: any, index: number) => (
                <div
                  key={index}
                  onClick={() => {
                    filtersToggleKappSelection(kapp);
                  }}
                  className={
                    kapp?.selected
                      ? styles.filterSelectedItem
                      : styles.filtersItem
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title={kapp?.name?.length > 24 ? kapp?.name : ""}
                  >
                    {kapp.selected && (
                      <img
                        src="/assets/icons/remove.svg"
                        alt="clear"
                        style={{
                          width: "10px",
                          height: "10px",
                        }}
                        onClick={(e) => {
                          // e.stopPropagation(); // Prevent the parent click event
                          removeTag({
                            name: kapp.value,
                            isKapp: false,
                          });
                        }}
                      />
                    )}

                    {kapp?.name?.length > 24
                      ? `${kapp?.name?.substring(0, 24)}...`
                      : kapp.name}
                  </div>
                </div>
              ))}
              {updatedKapps.length > 20 && !appearance.showAllKapps && (
                <div
                  onClick={() => dispatch(setShowAllKapps(true))}
                  className={styles.filtersItem}
                  style={{ cursor: "pointer", color: "blue" }}
                >
                  + Show More
                </div>
              )}
              {appearance.showAllKapps && (
                <div
                  onClick={() => dispatch(setShowAllKapps(false))}
                  className={styles.filtersItem}
                  style={{ cursor: "pointer", color: "blue" }}
                >
                  - Show Less
                </div>
              )}
            </div>
          )}
        </div>
      ) : null}

      {appearance.filtersType === "tags" &&
      search.tags?.filter(filterTagsForUI)?.length > 0 ? (
        <div className={styles.container}>
          <div className={styles.upperflexBox}>
            <div className={styles.flexBox}>
              <svg
                fill="#000000"
                height="12px"
                width="12px"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 330 330"
                xmlSpace="preserve"
                onClick={() => setOpenTage(!openTage)}
                style={{
                  transform: openTage ? "rotate(90deg)" : "",
                  cursor: "pointer",
                }}
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    id="XMLID_222_"
                    d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001 c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213 C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606 C255,161.018,253.42,157.202,250.606,154.389z"
                  ></path>{" "}
                </g>
              </svg>
              <p className={styles.subTitle}>Tags:</p>
            </div>
            <input placeholder="Search tag" onChange={handleTagsSearch} />
          </div>
          {openTage && (
            <div>
              {(appearance.showAllTags
                ? updatedTags?.filter(filterTagsForUI)
                : updatedTags?.filter(filterTagsForUI).slice(0, 20)
              ).map((tag: Tag, tagIndex: number) => {
                if (
                  updatedTags
                    .slice(0, tagIndex)
                    .findIndex((t: Tag) => t.value === tag.value) > -1
                ) {
                  return null;
                }
                return (
                  <div
                    className={
                      tag?.selected
                        ? styles.filterSelectedItem
                        : styles.filtersItem
                    }
                    onClick={() => {
                      tagClicked(tag);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "4px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      title={tag?.value?.length > 24 ? tag?.value : ""}
                    >
                      {tag.selected && (
                        <img
                          src="/assets/icons/remove.svg"
                          alt="clear"
                          style={{
                            width: "10px",
                            height: "10px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            removeTag({
                              name: tag.value,
                              isKapp: false,
                            });
                          }}
                        />
                      )}
                      {tag?.value?.length > 24
                        ? `${tag?.value?.substring(0, 24)}...`
                        : tag?.value}
                    </div>
                  </div>
                );
              })}
              {updatedTags.filter(filterTagsForUI).length > 20 &&
                !appearance.showAllTags && (
                  <div
                    onClick={() => dispatch(setShowAllTags(true))}
                    className={styles.filtersItem}
                    style={{ cursor: "pointer", color: "blue" }}
                  >
                    + Show More
                  </div>
                )}
              {appearance.showAllTags && (
                <div
                  onClick={() => dispatch(setShowAllTags(false))}
                  className={styles.filtersItem}
                  style={{ cursor: "pointer", color: "blue" }}
                >
                  - Show Less
                </div>
              )}
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default PortalTags;
